export default "<router-outlet>\n   <!--\n    <app-game>       \n    </app-game>\n\n  -->\n</router-outlet>\n"